import React, { FC } from 'react';
import { Span } from '../../components/Text/Text';
import { LangE } from '../../models/enums';
import { useAppSelector } from '../../store/hooks';
import { selectCurrentLang } from '../../store/selectors/appSelectors';

type AdvertiserNamePropTypes = {
    campaign: any;
    langPostfix?: 'EN' | 'En';
}

const AdvertiserName: FC<AdvertiserNamePropTypes> = (props) => {
    const { campaign, langPostfix = 'EN' } = props;
    const lang = useAppSelector(selectCurrentLang);
    const fieldNameWithLang = `AdvertiserName${langPostfix}`;

    const advertiserEn = campaign?.[fieldNameWithLang] ? campaign?.[fieldNameWithLang] : campaign?.AdvertiserName;
    const advertiserHe = campaign?.AdvertiserName;
    const title = campaign?.AdvertiserNameToolTip;

    return lang === LangE.EN ? (
        <>
            <span><Span title={title}>Advertiser</Span>:&nbsp;</span>
            <span title={title}>
                {advertiserEn} {(advertiserEn !== advertiserHe) ? (<span>- {advertiserHe}</span>) : ''}
            </span>
        </>
    ) : (
        <>
            <span><Span title={title}>Advertiser</Span>:&nbsp;</span>
            <span title={title}>
                {advertiserHe || advertiserEn}
            </span>
        </>
    );
};

export default AdvertiserName;